import { useState } from 'react';
import API from '../api';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('token', token);
      formData.append('new_password', newPassword);
      await API.post('/reset-password', formData);
      navigate('/login');
    } catch {
      alert('Reset failed');
    }
  };

  return (
    <form onSubmit={submit}>
      <h2>Reset Password</h2>
      <input placeholder="New Password" type="password" onChange={e => setNewPassword(e.target.value)} />
      <button type="submit">Reset</button>
    </form>
  );
}
